import * as globals from '@wandb/weave/common/css/globals.styles';
import {Dropdown as SemanticDropdown} from 'semantic-ui-react';
import styled, {css} from 'styled-components';

export const StyledDropdown = styled(SemanticDropdown)`
  .menu {
    > .item {
      // original semantic ui padding: 0.9375em 1.125em;
      // to add a hover state we have to increase margin and decrease padding
      // styles need !important or they'll be overridden by semantic ui stuff

      margin: 0 0.5em !important;
      padding: 0.625em !important;
      padding-right: 0 !important;
      border-radius: 4px !important;

      font-size: 16px !important;
      font-weight: 400 !important;
      line-height: 22px !important;

      height: 36px !important;
      width: 326px;

      display: flex !important;
      align-items: center;
      justify-content: space-between;

      :first-child {
        margin-top: 0.3125em !important;
      }

      :last-child {
        margin-bottom: 0.3125em !important;
      }
      background-color: ${globals.THEME.bgSurfaceRaised} !important;

      :hover {
        background-color: ${globals.THEME.bgSelected} !important;
      }
    }
    .selected.item {
      background-color: ${globals.THEME.bgSelected} !important;
      :hover {
        background-color: ${globals.THEME.bgSelected} !important;
      }
    }
  }
`;

export const StyledPermissionDropdown = styled(SemanticDropdown)<{
  $hasScrollbar: boolean;
  isOpen?: boolean;
}>`
  && > .left.menu {
    right: ${({$hasScrollbar}) => ($hasScrollbar ? '46px' : '32px')} !important;
  }
  .menu {
    position: fixed !important;
    margin-top: 2px !important;
    background-color: ${globals.THEME.bgSurfaceRaised} !important;
    // this is used to override semantics auto moving of the dropdown causing it to sometimes be transparent
    ${({isOpen}) => isOpen && 'bottom: 0;'}
  }
`;

export const DropdownItem = styled.div<{
  $selected: boolean;
  $destructive: boolean;
}>`
  cursor: pointer;
  margin: 0 6px;
  padding: 6px;
  border-radius: 4px;

  font-size: 16px;
  font-weight: 400;
  line-height: 22px;

  width: 180px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  :first-child {
    margin-top: 6px;
  }
  :last-child {
    margin-bottom: 6px;
  }

  color: ${globals.THEME.textPrimary};

  background-color: ${globals.THEME.bgSurfaceRaised};
  :hover {
    background-color: ${({$destructive}) =>
      $destructive ? globals.THEME.statusErrorBg : globals.THEME.bgSelected};
  }
  .checkIcon {
    color: ${globals.THEME.border};
  }

  ${({$selected}) =>
    $selected &&
    css`
      background-color: ${globals.THEME.bgSelected};
      :hover {
        background-color: ${globals.THEME.bgSelected};
      }
      .checkIcon {
        color: ${globals.THEME.textPrimary};
      }
    `}
`;

export const DropdownItemLeftWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DropdownDivider = styled.div`
  border-top: 1px solid ${globals.THEME.border};
  margin: 6px;
`;
